import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AppConfigModule } from 'app/app-config';
import { GoogleTagManagerService } from 'app/shared/services/analytics/google-tagmanager/gtm.service';
import { QuotePassiveTrackingService } from 'app/shared/services/fullstory/quote-passive-tracking/quote-passive-tracking.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppConfigModule],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  private gtmService = inject(GoogleTagManagerService);
  // Injected to bootstrap passive tracking — listeners wire up in the service constructor.
  private readonly quotePassiveTrackingService = inject(QuotePassiveTrackingService);

  ngOnInit() {
    this.gtmService.init();
  }
}
